import jwt_decode from 'jwt-decode'
export default {
    name: "BillApplyPayManage",
    data() {
        return {
            searchForm: {
                // 出单公司
                sendCompanyName: null,
                // 收单公司
				receiveCompanyName: null,
                // 打印状态
                printStatus: null,
                // 申请时间
                applyTime: null,
                // 初审时间
                firstAuditTime: null,
                // 终审时间
                fianlAuditTime: null,
                // // 申请人
                // applyName: null,
                // // 初审人
                // firstAuditName: null,
                // // 终审人
                // fianlAuditName: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0,
            loading: null,
            previewTitle: this.$t('s_BillApplyPayManage.verificationCode'),
            isPreview: false,
            tuePayForm: {
                verificationCode : ''
            },
            // TEU COIN 支付订单id
            transaction_id : ''
        }
    },
    computed: {
        rules() {
            return {
                verificationCode: [
                    {required: true, message: this.$t('s_BillApplyPayManage.verificationCodePlaceholder'), trigger: 'blur'},
                ],
            }
        },
    },
    methods: {
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.$refs.searchForm.resetFields();
		},
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            // 初审时间
            if(this.searchForm.firstAuditTime){
				param.firstAuditUserDayBeginTime = this.searchForm.firstAuditTime[0];
                param.firstAuditUserDayEndTime = this.searchForm.firstAuditTime[1];
                delete param.firstAuditTime;
            }
            // 初审时间
            if(this.searchForm.fianlAuditTime){
				param.finalAuditUserDayBeginTime = this.searchForm.fianlAuditTime[0];
                param.finalAuditUserDayEndTime = this.searchForm.fianlAuditTime[1];
                delete param.fianlAuditTime;
            }
            // 申请时间
            if(this.searchForm.applyTime){
				param.applyTimeBeginTime = this.searchForm.applyTime[0];
                param.applyTimeEndTime = this.searchForm.applyTime[1];
                delete param.applyTime;
            }
            // 如果查询条件中支付状态为已支付
            if (param.printStatus !== 7) {
                // 查询打印申请终审通过的 和 已支付的
                param.isPayStatusList = 1;
            }
            // 支付管理 查询已支付的时候，需要查询已打印的 打印管理中不应该包含（打印管理中未打印的应该查询已支付的）
            if (param.printStatus === 7) {
                param.isPaySearch = 1;
            }
            const token = sessionStorage.getItem('token');
            const tokenJson = jwt_decode(token);
            // 查询出单费公司id为当前登录人公司id
            param.sendBillFeeCompanyId = tokenJson.customerCompanyId;
            this.$axios.get('/api/prints/printManage', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        //单点登录云钱
        openYq(){
            this.$axios.get('/api/yqpay/yqwebsite').then(response => {
                if (response.data.status === '1') {
                    let langType = "CN";
                    if(this.$i18n.locale === "zh"){
                        langType = "EN";
                    }
                    window.open(response.data.url + "&lang_type=" + langType, "_blank");
                } else {
                    window.open(response.data.url, "_blank");
                }
            }).catch(e => {
                console.log(e)
            })
            
        },
        // 支付
        doPay() {
            let submitDate = new Object();
            submitDate = this.getSelectedRow();
            if (submitDate.printStatus === 7 || submitDate.printStatus === 5) {
                this.$message({
                    message: this.$t('s_BillApplyPayManage.message.isAlreadyPay'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            const param = {};
            param.id = submitDate.id;
            param.version = submitDate.version;
            param.costId = submitDate.costId;
            param.sendBillFeeCompanyId = submitDate.sendBillFeeCompanyId;
            param.printStatus = 7;
            param.payType = submitDate.payType;
            param.blNo = submitDate.blNo;
            param.sendCompanyId = submitDate.sendCompanyId;
            param.sendCompanyName = submitDate.sendCompanyName;
            param.receiveCompanyId = submitDate.receiveCompanyId;
            param.receiveCompanyName = submitDate.receiveCompanyName;
            let localParam = this.$i18n.locale;
            if (localParam.indexOf('en') !== -1) {
                param.lang_type = 'EN';
            } else {
                param.lang_type = 'CN';
            }
            this.$axios.put('/api/prints/billapplypay', param).then(response => {
                    let type = 'error';
                    if (response.data.status === '1') {
                        type = 'success';
                        // 余额支付
                        if (submitDate.payType === '1') {
                            this.$message({
                                message: this.$t(response.data.message),
                                type: type,
                                center: true
                            });
                            this.doSearch();
                        }
                        // 如果为TUE矿支付
                        if (submitDate.payType === '2' ) {
                            this.isPreview = true;
                            this.transaction_id = response.data.resultData;
                        }
                    } else {
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }
                }).catch(e => {
                    console.log(e);
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
            })
        },
        tuePay() {
            this.initWebSocket();
        },
        initWebSocket: function () {                
            // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https            
            const token = sessionStorage.getItem('token');    
            const tokenJson = jwt_decode(token);
            const userId = tokenJson.userAccountId;
            const url = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/socket`
			this.websock = new WebSocket(`${url}/websocket/${userId}`);                
			this.websock.onopen = this.websocketonopen;                
			this.websock.onerror = this.websocketonerror;                
			this.websock.onmessage = this.websocketonmessage;                
			this.websock.onclose = this.websocketclose;              
		},              
		websocketonopen () {                
            console.log("WebSocket连接成功");  
            this.$refs.tuePayForm.validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.tuePayForm);
                    let localParam = this.$i18n.locale;
                    console.log(localParam);
                    if (localParam.indexOf('en') !== -1) {
                        param.lang_type = 'EN';
                    } else {
                        param.lang_type = 'CN';
                    }
                    param.verify_code = param.verificationCode;
                    param.transaction_id = this.transaction_id;
                    console.log(param);
                    // 调用TEU COIN 支付接口，将验证码信息返回
                    this.$axios.get('/api/yqpay/sendcode', {params: param}).then(response => {
                        if (response.data.status === '1') {
                            console.log('success');
                            this.loading = this.$loading({
                                lock: true,
                                text: this.$t('s_BillApplyPayManage.toPay'),
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                        }else{
                            this.$message({
                                message: response.data.message,
                                type: 'error',
                                center: true
                            });
                        }
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });      
		},              
		websocketonerror: function (e) {                
			console.log("WebSocket连接发生错误", e);              
		},              
		websocketonmessage: function (e) {                
            console.log(e.data);  
            let type = 'error';
            if (e.data === 'SM-101') {
                type = 'success';
                // 调用返回输入验证码接口，成功后关闭dialog、重置表单
                this.isPreview = false;
                this.tuePayForm.verificationCode = '';
                this.doSearch();
            }   
            this.$message({
                message: this.$t(e.data),
                type: type,
                center: true
            });
        this.loading.close();
		},              
		websocketclose: function (e) {                
			console.log("connection closed (" + e.code + ")");              
		}
    }
}
